"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const styled_components_1 = __importDefault(require("styled-components"));
require("@veeam/components/lib/Tooltip/types");
const helpers_1 = require("@veeam/components/lib/Grid/cellRenderers/helpers");
const StyledTitle = styled_components_1.default(components_1.Text) `
  min-width: ${components_1.SPACING_M};
  line-height: 20px;
`;
const Title = ({ text }) => {
    const ref = react_1.useRef(null);
    return components_1.useTooltip({
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: components_1.TEXT_SIZE.s }, text),
        render: (tooltipProps) => {
            return (react_1.default.createElement(StyledTitle, { size: components_1.TEXT_SIZE.l, weight: components_1.TEXT_WEIGHT.bold, truncate: true, onMouseEnter: () => {
                    helpers_1.onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref)();
                }, onMouseLeave: () => {
                    tooltipProps.onMouseLeave();
                }, ref: ref }, text));
        },
    });
};
exports.Title = Title;
//# sourceMappingURL=Title.js.map